import { render } from "./SelectedSubscription.vue?vue&type=template&id=355126a5&scoped=true&ts=true"
import script from "./SelectedSubscription.vue?vue&type=script&lang=ts"
export * from "./SelectedSubscription.vue?vue&type=script&lang=ts"

import "./SelectedSubscription.vue?vue&type=style&index=0&id=355126a5&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-355126a5"]])

export default __exports__